// The function returns StructureData for Sitelinks search box.

export const addSearchBoxStructuredData = (
  siteUrl: string,
  pathHome: string | undefined,
  nodeLocale: string | undefined,
) => ({
  '@context': 'https://schema.org/',
  '@type': 'Website',
  url: `${siteUrl}${nodeLocale === 'nl-NL' ? '' : pathHome}`,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}${nodeLocale === 'nl-NL' ? '' : pathHome}/search?q={search_term_string}&lang=${nodeLocale}`,
    },
    'query-input': 'required name=search_term_string',
  },
});
